import React, { useEffect, useState, useRef } from "react";
import { bool, shape, string } from "prop-types";
import { connect, useDispatch } from "react-redux";
import { goBack, push } from "connected-react-router";
import { Field, Form, Formik } from "formik";
import { Col } from "react-bootstrap";
import * as Yup from "yup";

import { actions as onboardingActions, selectors as onboardingSelectors } from "reducers/onboarding";
import { actions as modalActions } from "reducers/modal";
import { selectors as enrollmentSelectors } from "reducers/enrollment";
import * as configUtils from "util/config";
import * as i18nUtils from "util/i18n";
import gaEventTracker, { events } from "util/gaEventTracker";
import { ResponsiveHeader } from "pages/_components/header";

import TextField from "pages/_components/fields/TextField";
import Button from "pages/_components/Button";
import Container from "pages/_components/Container";
import Head from "pages/_components/Head";
import MainContainer from "pages/_components/MainContainer";
import Image from "pages/_components/Image";
import CustomText from "pages/_components/CustomText/CustomText";
import GridTable from "pages/_components/GridTable/GridTable";
import ErrorPopup from "../../onboarding/_components/ErrorPopup";
import InfoModal from "../../onboarding/_components/InfoModal";

const FORM_ID = "onboarding.step.verifySMS";

const StepSmsMigration = ({ isMobile, verifyCode, invitationData, exchangeToken, onboardingWithEnrolledUser }) => {
    const dispatch = useDispatch();
    const [validateError, setvalidateError] = useState(false);

    const [error, setError] = useState("");
    const [isValidating, setIsValidating] = useState(false);
    const [resendAvailable, setResendAvailable] = useState(true);
    const [sendingCode, setSendingCode] = useState(true);
    const [invitationPhone, setInvitationPhone] = useState("");
    const TIME_TO_SEND_OTHER_CODE = configUtils.get("validation_code.retry.duration", 3) * 60000;

    const timerRef = useRef(null);

    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                () => {
                    gaEventTracker.triggerEvent(events.firmRegistry0);
                },
                () => {
                    setvalidateError(true);
                    // setError(
                    //     i18nUtils.get(
                    //         "permissions.user.geolocation.required",
                    //         "Sin otorgar estos permisos, no podrás continuar",
                    //     ),
                    // );
                    // setTimeout(() => {
                    //     dispatch(modalActions.modalShow());
                    // }, 500);
                },
            );
        }
    }, []);

    const sendCode = (mobilePhoneToSend, shouldDisableBtn) => {
        setIsValidating(true);
        dispatch(onboardingActions.verifyCodeSend("sms", "", mobilePhoneToSend || invitationPhone));
        if (shouldDisableBtn) {
            setResendAvailable(false);
            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => {
                setResendAvailable(true);
            }, TIME_TO_SEND_OTHER_CODE);
        }
    };

    useEffect(() => {
        if (invitationData && invitationData.phoneNumber && invitationData.phoneNumber.phoneNumber !== "") {
            const { countryCode, areaCode, value } = invitationData.phoneNumber;
            setInvitationPhone(countryCode + areaCode + value);
        }
    }, [invitationData]);

    useEffect(() => {
        if (invitationPhone) {
            sendCode(invitationPhone, false);
        }
    }, [invitationPhone]);

    useEffect(() => {
        if (isValidating && verifyCode?.data && verifyCode?.status !== "OK" && verifyCode?.status !== "") {
            setIsValidating(false);
            setError(verifyCode?.data.message);
            dispatch(modalActions.modalShow());
            dispatch(onboardingActions.resetVerifyCode());
        } else if (isValidating && verifyCode?.status === "OK" && verifyCode?.type === "receive") {
            setIsValidating(false);
            dispatch(onboardingActions.resetVerifyCode());
            dispatch(push("/migration/stepSmsSuccess"));
        } else if (isValidating && verifyCode?.status === "OK" && verifyCode?.type === "send") {
            setSendingCode(false);
        }
    }, [isValidating, verifyCode]);

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    const formikValidateProps = {
        validateOnChange: true,
        validateOnBlur: false,
        initialValues: {
            code: "",
            code1: "",
            code2: "",
            code3: "",
            code4: "",
            code5: "",
        },
        validationSchema: () =>
            Yup.object()
                .shape({
                    code: Yup.string(),
                    code1: Yup.string(),
                    code2: Yup.string(),
                    code3: Yup.string(),
                    code4: Yup.string(),
                    code5: Yup.string(),
                })
                .test("errors", " ", (values) => {
                    const { code, code1, code2, code3, code4, code5 } = values;
                    if (!code || !code1 || !code2 || !code3 || !code4 || !code5) {
                        return false;
                    }
                    return true;
                }),
        onSubmit: (event, data) => {
            const { code, code1, code2, code3, code4, code5 } = data;
            const codeSend = `${code}${code1}${code2}${code3}${code4}${code5}`;
            setIsValidating(true);
            dispatch(
                onboardingActions.verifyCodeReceiveMigration(codeSend, "sms", "", invitationPhone, exchangeToken, true),
            );
        },
    };

    const handleStopTimer = (e) => {
        // chequea que el click no sea desde el input o que no sea desde los botones
        if (e.target.localName !== "input" && e.target.parentElement.id === "") {
            clearTimeout(timerRef.current);
        }
    };

    const handleSendCode = (e) => {
        sendCode(invitationPhone, true);
        e.stopPropagation();
    };

    const handleOnSubmit = (formikPropsParam, event, data) => {
        event.stopPropagation();
        formikPropsParam.onSubmit(event, data);
    };

    const onFocus = (id, value) => {
        if (value === "") {
            return;
        }
        if (document.getElementById(id)) {
            document.getElementById(id).focus();
        }
    };

    const onFocusDown = (id, code, idLast, setFieldValue, value) => {
        if (code === "Backspace" && value === "") {
            if (document.getElementById(id)) {
                document.getElementById(id).focus();
            }
            if (idLast) {
                setFieldValue(idLast, "");
            }
        }
    };

    const createValidateEmailBodyModal = () => (
        <div>
            <Formik {...formikValidateProps}>
                {(allFormik) => (
                    <Form className="above-the-fold" noValidate>
                        <GridTable className="token-code-fields">
                            <GridTable.Container>
                                <GridTable.Data>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        name="code"
                                        id="code"
                                        hideLabel
                                        onKeyUp={(e) => {
                                            onFocus("code1", e.target.value);
                                        }}
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                                <GridTable.Data sm={1}>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        name="code1"
                                        id="code1"
                                        onKeyUp={(e) => {
                                            onFocus("code2", e.target.value);
                                        }}
                                        hideLabel
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        onKeyDown={(e) => {
                                            onFocusDown("code", e.code || e.key, null, null, allFormik.values.code1);
                                        }}
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                                <GridTable.Data sm={1}>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        onKeyUp={(e) => {
                                            onFocus("code3", e.target.value);
                                        }}
                                        name="code2"
                                        id="code2"
                                        hideLabel
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        onKeyDown={(e) => {
                                            onFocusDown("code1", e.code || e.key, null, null, allFormik.values.code2);
                                        }}
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                                <GridTable.Data sm={1}>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        onKeyUp={(e) => {
                                            onFocus("code4", e.target.value);
                                        }}
                                        name="code3"
                                        id="code3"
                                        hideLabel
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        onKeyDown={(e) => {
                                            onFocusDown("code2", e.code || e.key, null, null, allFormik.values.code3);
                                        }}
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                                <GridTable.Data sm={1}>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        name="code4"
                                        id="code4"
                                        onKeyUp={(e) => {
                                            onFocus("code5", e.target.value);
                                        }}
                                        hideLabel
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        onKeyDown={(e) => {
                                            onFocusDown("code3", e.code || e.key, null, null, allFormik.values.code4);
                                        }}
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                                <GridTable.Data sm={1}>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        name="code5"
                                        id="code5"
                                        hideLabel
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        onKeyDown={(e) => {
                                            onFocusDown(
                                                "code4",
                                                e.code || e.key,
                                                "code5",
                                                allFormik.setFieldValue,
                                                allFormik.values.code5,
                                            );
                                        }}
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                            </GridTable.Container>
                        </GridTable>
                        {Object.keys(allFormik.errors).length > 0 && (
                            <div className="error">{allFormik.errors[Object.keys(allFormik.errors)[0]]}</div>
                        )}

                        <Button
                            bsStyle="link"
                            // label="onboarding.step.verifyEmail.modal.resendcode.action"
                            defaultLabelText="No me llegó el SMS"
                            loading={false}
                            onClick={handleSendCode}
                            disabled={!resendAvailable}
                            id="save-mobilePhone-button"
                        />

                        <Button
                            bsStyle="primary"
                            label="onboarding.step.verifySMS.modal.button.validate"
                            loading={false}
                            onClick={(ev) => handleOnSubmit(formikValidateProps, ev, allFormik.values)}
                            block
                            disabled={
                                !(
                                    allFormik.isValid &&
                                    allFormik.dirty &&
                                    allFormik.values.code?.length === 1 &&
                                    allFormik.values.code1?.length === 1 &&
                                    allFormik.values.code2?.length === 1 &&
                                    allFormik.values.code3?.length === 1 &&
                                    allFormik.values.code4?.length === 1 &&
                                    allFormik.values.code5?.length === 1
                                )
                            }
                            id="submit-button"
                        />
                    </Form>
                )}
            </Formik>
        </div>
    );

    const onhandleClickAlert = () => {
        dispatch(modalActions.modalClose());
        setError("");
    };
    if (validateError) {
        return (
            <>
                {isMobile && (
                    <ResponsiveHeader
                        ticket
                        id={i18nUtils.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                        onClickBack={isMobile && onHeaderBack}
                    />
                )}
                <MainContainer>
                    {!isMobile && (
                        <Container>
                            <Col xs={12} md={8} mdOffset={2}>
                                <ResponsiveHeader
                                    ticket
                                    id={i18nUtils.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                                    onClickBack={isMobile && onHeaderBack}
                                />
                            </Col>
                        </Container>
                    )}

                    <Col xs={12} md={8} mdOffset={2}>
                        <h1 className="text-center">
                            <CustomText text={i18nUtils.get("", "Permiso de geolocalización rechazado")} />
                        </h1>
                    </Col>
                    <div className="illustration text-center">
                        <Image src="figma/illustrations/onboarding13.svg" className="svg-image logo" />
                    </div>
                    {/* <Col xs={12} md={8} mdOffset={2}>
                        <div className="bienvenida-alta-persona">Ilustración</div>
                    </Col> */}
                    <div className="box box-border-soft">
                        <CustomText text={i18nUtils.get("", "No podemos continuar con el proceso de onboarding.")} />
                        <CustomText
                            text={i18nUtils.get("", "Se necesita aceptar permisos para continuar con la navegación.")}
                        />
                    </div>

                    <Button
                        bsStyle="primary"
                        label="file.upload.input.labelButtonRetryItemLoad"
                        loading={false}
                        onClick={() => {
                            setvalidateError(false);
                            dispatch(push("/"));
                        }}
                    />
                </MainContainer>
            </>
        );
    }
    return (
        <>
            {isMobile && <ResponsiveHeader id="onboarding.noUser.title" onClickBack={onHeaderBack} showCenterContent />}
            <MainContainer showLoader={sendingCode}>
                {!isMobile && <Head title="onboarding.noUser.title" onBack={isMobile && onHeaderBack} />}

                {!sendingCode && !error && (
                    <InfoModal
                        noAcceptButton
                        noCancelButton
                        bodyInfoText="texto"
                        modalSubtitle={`Ingresá el código de validación enviado por sms al +${invitationPhone}`}
                        useScroll
                        body={createValidateEmailBodyModal}
                        onClick={handleStopTimer}
                    />
                )}
            </MainContainer>
            <ErrorPopup error={error} handleClick={onhandleClickAlert} />
        </>
    );
};

StepSmsMigration.propTypes = {
    isMobile: bool.isRequired,
    invitationData: shape({}),
    exchangeToken: string.isRequired,
    verifyCode: shape({}),
    onboardingWithEnrolledUser: bool.isRequired,
};

StepSmsMigration.defaultProps = {
    verifyCode: {},
    invitationData: {},
};

const mapStateToProps = (state) => ({
    verifyCode: onboardingSelectors.getVerifyCode(state),
    invitationData: onboardingSelectors.getInvitationData(state),
    exchangeToken: enrollmentSelectors.getExchangeToken(state),
    onboardingWithEnrolledUser: onboardingSelectors.getOnboardingWithEnrolledUser(state),
});

export default connect(mapStateToProps)(StepSmsMigration);
